import React, { useState } from "react";
import { SearchDropDownWithBase } from "../../../../components";
import queryString from "query-string";
// import utils from "../../../../utils";
// import {useNavigate} from "react-router-dom";
import values from "../../../../values";
import Context from "../../../../context";
import { IOnSearchUser } from "../../../../types/common.interface";
import utils from "../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../values/constants";

interface iOnSearch {
  searchedValue: string;
  base: {
    title: string;
    value: string;
  };
}

const SearchAgent = () => {
  // ============================ Value Validations =========================

  // const navigate = useNavigate();
  const [defaultSearch, setDefaultSearch] = useState<string>(
    String(queryString.parse(window.location.search).search)?.split(":")[1]
  );
  const { requestCompany, setRequestCompany } = React.useContext(
    Context.CompanyScreen
  );

  const baseSearch = values.dropdownBaseSearch.COMPANY_BASE_SEARCH;

  // =============================== Navigation =============================

  function onSearch(event: IOnSearchUser) {
    setRequestCompany!({
      ...requestCompany,
      search: {
        base: event?.base?.value,
        value: event?.searchedValue,
      },
    });
    return false;
  }

  // ============================== JSX Contents ============================

  return (
    <SearchDropDownWithBase
      icon="fa-solid fa-magnifying-glass"
      defaultSearch={defaultSearch}
      size="medium-sd"
      onChangeSearch={(event: iOnSearch) => {
        onSearch(event);
        setDefaultSearch(event.searchedValue);
      }}
      defaultBaseSearch={baseSearch[0]}
      baseSearchItems={baseSearch}
    />
  );
};

export default SearchAgent;
